import React, { ComponentProps } from 'react'
import { useTranslation } from 'hooks/useTranslation'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { AllProductsRoot } from './AllProducts.styles'
import { Footer } from 'components/Footer'
import { Hero } from './components/Hero'
import { FeedBetter } from './components/FeedBetter'
import { DogBiology } from './components/DogBiology'
import { WhatYouNeed } from './components/WhatYouNeed'
import { PerfectlyFormulated } from './components/PerfectlyFormulated'
import { OwnPace } from './components/OwnPace'
import { CtaFooter } from 'features/Home/components/CtaFooter'

type ProductsOwnProps = ComponentProps<typeof AllProductsRoot>
export type ProductsProps = ProductsOwnProps & {}

export const AllProducts = (_props: ProductsProps) => {
  const { t } = useTranslation()
  const header = <Header />

  return (
    <AllProductsRoot>
      <Layout header={header}>
        <Hero />
        <FeedBetter />
        <PerfectlyFormulated />
        <WhatYouNeed />
        <OwnPace />
        <DogBiology />
        <CtaFooter hideSecondaryCta title="products-v2:all-products.bottom-cta.headline" />
        <Footer />
      </Layout>
    </AllProductsRoot>
  )
}

AllProducts.displayName = 'AllProducts'
